import { Component, OnInit, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { WorkOrderService } from '../../services/work-order.service';
import { TasksService } from '../../services/tasks.service';
import { IWorkOrder } from '../new-work-order/new-work-order.component';
import { NgForm, FormControl } from '@angular/forms';
import { NotifierService } from '../../shared/notifier/notifier.service';
import { UploadService } from '../../services/upload.service';
import { UserService } from '../../services/usuario.service';
import { map, startWith } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-internal-work-order',
  templateUrl: 'internal-work-order.component.html',
  styles: ['internal-work-order.component.scss'],
  providers: [WorkOrderService, TasksService, UploadService, UserService]
})
export class InternalWorkOrderComponent implements OnInit {
  idWorkOrder: number;
  idInternalWorkOrder: number;
  internalWorkOrderData: IInternalWorkOrder;
  workOrderData: IWorkOrder;
  listTasks: Array<IRawTask>;
  taskInternalWorkOrderData: IRawTask;
  tasksToAdd: Array<ITaskInternalWorkOrder>;
  attachments: Array<IAttachment>;
  userList: Array<IUser>;
  userToAdd: Array<IUser>;
  userSelectedData: IUser;
  uploading = false;
  mailSelected: string = '';
  taskSelected: string = '';

  myControlCorreo = new FormControl();
  options: string[] = [];
  filteredOptions: Observable<string[]>;

  myControlTasks = new FormControl();
  optionsTasks: string[] = [];
  filteredTasks: Observable<string[]>;

  constructor(private route: ActivatedRoute,
    private workOrderService: WorkOrderService,
    private taskService: TasksService,
    private zone: NgZone,
    private notifierService: NotifierService,
    private routes: Router,
    private uploadService: UploadService,
    private userService: UserService) {

    this.tasksToAdd = [];
    this.attachments = [];
    this.userToAdd = [];
    this.userSelectedData = {};
    this.route.params.subscribe((params) => {
      if (params['idWorkOrder']) {
        this.idWorkOrder = params['idWorkOrder'];
        this.workOrderService.getWorkOrder(params['idWorkOrder']).subscribe((workOrder: IWorkOrder) => {
          this.workOrderData = workOrder;
        });
        this.internalWorkOrderData = {
          work_order_id: Number(params['idWorkOrder']),
          aperture_date: new Date(),
          detail: ''
        };

        if (!params['idInternalWorkOrder']) {
          this.taskService.getAllTask().subscribe((listTasks: Array<IRawTask>) => {
            for (const item of listTasks) {
              item.action = EActions.ADD;
            }
            this.listTasks = listTasks;

            this.listTasks.sort(function (a, b) {
              if (a.name > b.name) {
                return 1;
              }
              if (a.name < b.name) {
                return -1;
              }
              // a must be equal to b
              return 0;
            });
            for (const item of this.listTasks) {
              item.action = EActions.ADD;
              this.optionsTasks.push(item.name);
            }

            this.filteredTasks = this.myControlTasks.valueChanges
              .pipe(
                startWith(''),
                map(value => this._filter(value,this.optionsTasks))
              );
          });
        }
      }
      if (params['idInternalWorkOrder']) {
        this.idInternalWorkOrder = params['idInternalWorkOrder'];
        this.workOrderService.getInternalWorkOrder(this.idInternalWorkOrder).subscribe((internalWorkOrder: IInternalWorkOrder) => {
          this.internalWorkOrderData = internalWorkOrder;
          this.taskService.getAllTask().subscribe((listTasks: Array<IRawTask>) => {
            this.listTasks = listTasks;
            this.listTasks.sort(function (a, b) {
              if (a.name > b.name) {
                return 1;
              }
              if (a.name < b.name) {
                return -1;
              }
              // a must be equal to b
              return 0;
            });
            for (const item of this.listTasks) {
              item.action = EActions.ADD;
              this.optionsTasks.push(item.name);
            }

            this.filteredTasks = this.myControlTasks.valueChanges
              .pipe(
                startWith(''),
                map(value => this._filter(value,this.optionsTasks))
              );
          });
          this.taskService.tasksByInternalWorkOrder(this.idInternalWorkOrder).subscribe((listTasks: Array<ITaskInternalWorkOrder>) => {
            for (const item of listTasks) {
              item.action = EActions.EXIST;
            }
            this.tasksToAdd = listTasks;
          }, (error) => {
            console.log(error);
          });
          this.workOrderService.getAttachmentsByInternalWorkOrder(this.idInternalWorkOrder).subscribe((listAttachments: Array<any>) => {
            for (const item of listAttachments) {
              item.action = EActions.EXIST;
            }
            this.attachments = listAttachments;
          }, (error) => {
            console.log(error);
          });
          this.workOrderService.getContactsByInternalWorkOrder(this.idInternalWorkOrder).subscribe((listContacts: Array<any>) => {
            for (const item of listContacts) {
              item.action = EActions.EXIST;
            }
            this.userToAdd = listContacts;
          }, (error) => {
            console.log(error);
          });
        });
      } else {
        this.idInternalWorkOrder = undefined;
      }
    });
  }
  private async saveInternalWorkOrder() {
    try {
      return <IInternalWorkOrder>await this.workOrderService.createInternalWorkOrder(this.internalWorkOrderData).toPromise();
    } catch (e) {
      throw e;
    }
  }
  private async updateInternalWorkOrderData() {
    try {
      return <IInternalWorkOrder>
        await this.workOrderService.updateInternalWorkOrder(this.internalWorkOrderData, this.internalWorkOrderData.id).toPromise();
    } catch (e) {
      throw e;
    }
  }

  private async saveTasksByInternalWorkOrder(internalWorkOrderObject: IInternalWorkOrder) {
    try {
      for (const item of this.tasksToAdd) {
        item.id_internal_work_order = internalWorkOrderObject.id;
      }
      return await this.taskService.updateTasksByInternalWorkOrder(this.tasksToAdd, internalWorkOrderObject.id).toPromise();
    } catch (e) {
      throw e;
    }
  }

  private async saveAttachmentsByInternalWorkOrder(internalWorkOrderObject: IInternalWorkOrder) {
    try {
      for (const item of this.attachments) {
        item.id_internal_work_order = internalWorkOrderObject.id;
      }
      return await this.workOrderService.updateAttachmentsByInternalWorkOrder(this.attachments, internalWorkOrderObject.id).toPromise();
    } catch (e) {
      throw e;
    }
  }

  private async saveContactsByInternalWorkOrder(internalWorkOrderObject: IInternalWorkOrder) {
    try {
      for (const item of this.userToAdd) {
        item.id_internal_work_order = internalWorkOrderObject.id;
      }
      return await this.workOrderService.updateContactsByInternalWorkOrder(this.userToAdd, internalWorkOrderObject.id).toPromise();
    } catch (e) {
      throw e;
    }
  }

  private _filter(value: string, options): string[] {
    const filterValue = value.toLowerCase();

    return options.filter(option => option.toLowerCase().includes(filterValue));
  }

  ngOnInit() {
    this.userService.getUsersList().subscribe((result: Array<IUser>) => {
      console.table(result);
      this.userList = result;
      this.userList.sort(function (a, b) {
        if (a.nombre_completo > b.nombre_completo) {
          return 1;
        }
        if (a.nombre_completo < b.nombre_completo) {
          return -1;
        }
        // a must be equal to b
        return 0;
      });
      this.userList.forEach(element => {
        this.options.push(element.nombre_completo);
      });
    });

    this.filteredOptions = this.myControlCorreo.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value,this.options))
      );
  }

  createTask() {

  }

  async createInternalWorkOrder(InternalWorkOrderForm: NgForm) {
    if (InternalWorkOrderForm.valid) {
      this.notifierService.systemNotify({
        title: 'Espere',
        message: 'Grabando Orden de trabajo',
        type: 'info',
        duration: 20000
      });
      try {
        // Save InternalWorkOrder
        const internalWorkOrderResult = await this.saveInternalWorkOrder();
        // Save TasksByInternalWorkOrder
        await this.saveTasksByInternalWorkOrder(internalWorkOrderResult);
        // Save AttachmentsByInternalWorkOrder
        await this.saveAttachmentsByInternalWorkOrder(internalWorkOrderResult);
        // Save ContactsByInternalWorkOrder
        await this.saveContactsByInternalWorkOrder(internalWorkOrderResult);
        this.notifierService.systemNotify({
          title: 'Exito',
          message: 'Orden de Trabajo Interna Creada',
          type: 'success'
        });
        this.routes.navigate(
          ['/system/work-order/internal-work-order/edit/' +
            internalWorkOrderResult.work_order_id + '/' + internalWorkOrderResult.id]);
      } catch (e) {
        this.notifierService.systemNotify({
          title: 'Error',
          message: 'Ha ocurrido un error por favor contactese con el administrador',
          type: 'error'
        });
      }
    } else {
      this.notifierService.systemNotify({
        title: 'Error',
        message: 'Por favor asegurese que todos los campos estén llenados correctamente',
        type: 'error'
      });
    }
  }

  async updateInternalWorkOrder(InternalWorkOrderForm: NgForm) {
    if (InternalWorkOrderForm) {
      if (InternalWorkOrderForm.valid) {
        this.notifierService.systemNotify({
          title: 'Espere',
          message: 'Grabando Orden de trabajo',
          type: 'info',
          duration: 20000
        });
        try {
          // Update InternalWorkOrder
          const internalWorkOrderResult = await this.updateInternalWorkOrderData();
          // Update TasksByInternalWorkOrder
          await this.saveTasksByInternalWorkOrder(internalWorkOrderResult);
          // Update AttachmentsByInternalWorkOrder
          await this.saveAttachmentsByInternalWorkOrder(internalWorkOrderResult);
          // Update ContactsByInternalWorkOrder
          await this.saveContactsByInternalWorkOrder(internalWorkOrderResult);
          this.notifierService.systemNotify({
            title: 'Exito',
            message: 'Orden de Trabajo Interna Actualizada',
            type: 'success'
          });
          this.routes.navigate(
            ['/system/work-order/internal-work-order/edit/' +
              internalWorkOrderResult.work_order_id + '/' + internalWorkOrderResult.id]);
        } catch (e) {
          this.notifierService.systemNotify({
            title: 'Error',
            message: 'Ha ocurrido un error por favor contactese con el administrador',
            type: 'error'
          });
        }
      }
    } else {
      this.notifierService.systemNotify({
        title: 'Error',
        message: 'Por favor asegurese que todos los campos estén llenados correctamente',
        type: 'error'
      });
    }
  }

  removeAttachment(item) {
    item.action = EActions.REMOVE;
  }

  removeContact(item) {
    item.action = EActions.REMOVE;
  }

  addEmailUser() {
    var userS = this.userList.find((item) => {
      // tslint:disable-next-line:triple-equals
      return item.nombre_completo == this.mailSelected;
    });
    this.zone.run(() => {
      const found = this.userToAdd.find((object: any) => {
        return (object.id === userS.id) && (!object.id_user);
      });
      const found2 = this.userToAdd.find((object: any) => {
        return object.id_user === userS.id;
      });
      /*if (!found) {
        console.table(this.userSelectedData);
        this.userSelectedData.action = EActions.ADD;
        this.userToAdd.push({ ... this.userSelectedData });
        this.userSelectedData.action = EActions.EXIST;
      }
      console.table(this.userToAdd);*/
      if (!found && !found2) {
        console.table(userS);
        userS.action = EActions.ADD;
        this.userToAdd.push({ ...userS });
        userS.action = EActions.EXIST;
      }
      console.table(this.userToAdd);
      this.mailSelected = '';
    });

  }

  addTask() {
    var taskS = this.listTasks.find((item) => {
      // tslint:disable-next-line:triple-equals
      return item.name == this.taskSelected;
    });
    const found = this.tasksToAdd.find((object) => {
      return object.name === taskS.name;
    });
    if (found) {
      this.zone.run(() => {
        found.action = EActions.EXIST;
      });
    } else {
      const itemtoAdd: ITaskInternalWorkOrder = {
        id_task: taskS.id,
        action: EActions.ADD,
        name: taskS.name,
        id_internal_work_order: this.idWorkOrder
      };
      taskS.action = EActions.EXIST;
      this.zone.run(() => {
        this.tasksToAdd.push(itemtoAdd);
      });
    }
    this.taskSelected = '';
  }

  removeTask(task: ITaskInternalWorkOrder) {
    task.action = EActions.REMOVE;
    const found = this.listTasks.find((object) => {
      return object.id === task.id_task && object.name === task.name;
    });
    if (found) {
      found.action = EActions.ADD;
    }
    //console.table(this.listTasks);
    //console.table(this.tasksToAdd);
  }

  fileChange(event) {
    const listFile: FileList = event.target.files;
    if (listFile.length > 0) {
      this.uploading = true;
      const filetoSend: File = listFile[0];
      this.uploadService.uploadAttachment(filetoSend).subscribe((result: IAttachment) => {
        console.log(result);
        this.zone.run(() => {
          result.action = EActions.ADD;
          this.attachments.push(result);
          this.uploading = false;
          this.notifierService.systemNotify({
            title: 'Éxito',
            message: 'Se ha subido el video de alta resolución con éxito',
            type: 'success'
          });
        }, error => {
          this.notifierService.systemNotify({
            title: 'Error',
            message: 'No se ha podido subir el video de alta resolución ',
            type: 'error'
          });
          this.uploading = false;
        });
      });
    }
  }
  fireOpenEvent(elementToFire) {
    if (elementToFire === 'attachment') {
      const element: HTMLElement = document.getElementById('attachment');
      element.click();
    }
  }
  addContact(contact: IUser) {
    this.userToAdd.push(contact);
  }
}

enum EActions {
  ADD = 'A',
  CREATE = 'C',
  REMOVE = 'R',
  EXIST = 'E'
}

export interface IInternalWorkOrder {
  id?: number;
  work_order_id: number;
  external_code?: string;
  aperture_date: Date;
  close_date?: Date;
  detail: string;
  create_date?: Date;
  update_date?: Date;
  create_user?: number;
  update_user?: number;
  tenant?: string;
  correlative?: number;

}

export interface IRawTask {
  id?: number;
  tenant?: string;
  name?: string;
  common_task?: boolean;
  hourly_rate?: number;
  created_date?: Date;
  updated_date?: Date;
  active?: boolean;
  action?: EActions;
}

export interface ITaskInternalWorkOrder {
  id?: number;
  id_task: number;
  id_internal_work_order?: number;
  name?: string;
  action?: EActions;
}

export interface IAttachment {
  id?: number;
  id_internal_work_order?: number;
  url?: string;
  name?: string;
  file_name?: string;
  action?: EActions;
}

export interface IUser {
  nombre_completo?: string;
  id?: string;
  codigo?: string;
  nombres?: string;
  apellidos?: string;
  correo?: string;
  celular?: string;
  estado?: string;
  rol?: number;
  sexo?: string;
  tipo_usuario?: number;
  rolNombre?: string;
  capacity_hours?: number;
  id_area?: number;
  name_area?: number;
  action?: EActions;
  id_internal_work_order?: number;
}




// WEBPACK FOOTER //
// ./src/app/system/work-order/internal-work-order/internal-work-order.component.ts